import React from 'react';

import mainImage from '../../assets/main-image.png';
import Section from '../Section';
import Logo from '../Logo';
import { ReactComponent as EllipseIcon } from '../../assets/icons/ellipse.svg';
import { ReactComponent as DoubleStarsIcon } from '../../assets/icons/double-stars-icon.svg';

import styles from './AuthSection.module.scss';

export interface AuthSectionProps {
  className?: string;
  children: React.ReactNode;
}

export function AuthSection({ children, className }: AuthSectionProps) {
  return (
    <Section className={`${styles.doubleColumnSection} ${className}`}>
      <div className={styles.contentWrapper}>
        <Logo className={styles.logo} />
        <DoubleStarsIcon className={styles.topLeft} />
        <DoubleStarsIcon className={styles.topRight} />
        <div className={styles.left}>{children}</div>
        <div className={styles.right}>
          <>
            <div className={styles.rightContent}>
              <h1>NUMIQUE</h1>
              <img src={mainImage} alt="" />
              <div className={styles.description}>
                <p>
                  В Numique мы используем три проверенных методики из нумерологии для глубокого анализа вашей личности и
                  формирования уникального отчета. Наш подход объединяет данные из матрицы судьбы, дизайна человека и
                  психоматрицы, чтобы создать уникальный опыт благодаря которому вы сможете познать себя еще лучше.
                </p>
              </div>
            </div>
            <EllipseIcon className={styles.ellipse} />
          </>
        </div>
        <DoubleStarsIcon className={styles.bottomLeft} />
        <DoubleStarsIcon className={styles.bottomRight} />
      </div>
    </Section>
  );
}
